module.exports = __webpack_public_path__ + "static/media/white-thick.6b0a0c73.svg";